import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";
import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { walletServices } from "@/services/api/cresivoxServer";

import {iApprovedStatus, iWithdrawDTO, REDUCER_NAME} from "./Types";
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const addMoneyToWallet = createAsyncThunk<
iGenericResponse<any | null> | null,
{
amount:number,
currency:string,
planId?: string;
paymentPreference?: string;
savedPaymentMethodId?: string | null;
},
{
    rejectValue: iStateMessage;
}
>(
curriedGetThunkName("addMoneyToWallet"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({amount,currency,planId,paymentPreference,savedPaymentMethodId}, {rejectWithValue}) => {
    try {
        const af_id =
        typeof document !== "undefined"
          ? document.cookie
              .split("; ")
              .find((row) => row.startsWith("af_id="))
              ?.split("=")[1] || null
          : null;
        const response = await walletServices.addMoneyToWallet(
            amount,
            currency,
            planId,
            af_id,
            paymentPreference,
            savedPaymentMethodId
        );
        if (response) {
            const {httpStatusCode, data, message} = response;

            switch (httpStatusCode) {
                case httpStatusCodes.SUCCESS_OK: {
                    if (data && data.data) {
                        return {
                            data: {
                                data: data.data,
                                message,
                            }
                        };
                    } else {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
                default: {
                    return rejectWithValue({
                        httpStatusCode,
                        message,
                    });
                }
            }
        } else {
            return rejectWithValue({
                message: "No response received",
            });
        }
    } catch (error) {
        return rejectWithValue({
            message: "Something went wrong",
        });
    }
},
);

export const verifyPayment = createAsyncThunk<
iGenericResponse<any | null> | null,
{transactionId:string},
{
    rejectValue: iStateMessage;
}
>(
curriedGetThunkName("verifyPayment"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({transactionId}, {rejectWithValue}) => {
    try {
        const response = await walletServices.verifyPayment(transactionId); // ✅ Ensure correct structure
        if (response) {
            const {httpStatusCode, data, message} = response;
            switch (httpStatusCode) {
                case httpStatusCodes.SUCCESS_OK: {
                    if (data && data.data) {
                        return {
                            data: {
                                data: data.data,
                                message,
                            }
                        };
                    } else {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
                default: {
                    return rejectWithValue({
                        httpStatusCode,
                        message,
                    });
                }
            }
        } else {
            return rejectWithValue({
                message: "No response received",
            });
        }
    } catch (error) {
        return rejectWithValue({
            message: "Something went wrong",
        });
    }
},
);


export const verifyBuildAppPayment = createAsyncThunk<
iGenericResponse<any | null> | null,
{transactionId:string},
{
    rejectValue: iStateMessage;
}
>(
curriedGetThunkName("verifyBuildAppPayment"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({transactionId}, {rejectWithValue}) => {
    try {
        const response = await walletServices.verifyBuildAppPayment(transactionId); // ✅ Ensure correct structure
        if (response) {
            const {httpStatusCode, data, message} = response;
            switch (httpStatusCode) {
                case httpStatusCodes.SUCCESS_OK: {
                    if (data && data.data) {
                        return {
                            data: {
                                data: data.data,
                                message,
                            }
                        };
                    } else {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
                default: {
                    return rejectWithValue({
                        httpStatusCode,
                        message,
                    });
                }
            }
        } else {
            return rejectWithValue({
                message: "No response received",
            });
        }
    } catch (error) {
        return rejectWithValue({
            message: "Something went wrong",
        });
    }
},
);

export const getAllTransactionListOfWallet = createAsyncThunk<
  iGenericResponse<any | null> | null,
{ page?: number; limit?: number } | void,
  {
      rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getAllTransactionListOfWallet"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (arg, {rejectWithValue}) => {
      try {
          const response = await walletServices.getAllTransactionListOfWallet(arg || undefined);
          if (response) {
              const {httpStatusCode, data, message} = response;

              switch (httpStatusCode) {
                  case httpStatusCodes.SUCCESS_OK: {
                      if (data && data.data) {
                          return {
                            data:{
                                httpStatusCode,
                              data: data.data,
                              message,
                            }
                              
                          };
                      } else {
                          return rejectWithValue({
                              httpStatusCode,
                              message,
                          });
                      }
                  }
                  default: {
                      return rejectWithValue({
                          httpStatusCode,
                          message,
                      });
                  }
              }
          } else {
              return rejectWithValue({
                  message: "No response received",
              });
          }
      } catch (error) {
          return rejectWithValue({
              message: "Something went wrong",
          });
      }
  },
);

export const getMinimumWalletAmount = createAsyncThunk<
  iGenericResponse<any | null> | null,
void,
  {
      rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getMinimumWalletAmount"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (arg, {rejectWithValue}) => {
      try {
          const response = await walletServices.getMinimumWalletAmount();
          if (response) {
              const {httpStatusCode, data, message} = response;

              switch (httpStatusCode) {
                  case httpStatusCodes.SUCCESS_OK: {
                      if (data && data.data) {
                          return {
                            data:{
                                httpStatusCode,
                              data: data.data,
                              message,
                            }
                              
                          };
                      } else {
                          return rejectWithValue({
                              httpStatusCode,
                              message,
                          });
                      }
                  }
                  default: {
                      return rejectWithValue({
                          httpStatusCode,
                          message,
                      });
                  }
              }
          } else {
              return rejectWithValue({
                  message: "No response received",
              });
          }
      } catch (error) {
          return rejectWithValue({
              message: "Something went wrong",
          });
      }
  },
);

export const withdrawMoney = createAsyncThunk<
iGenericResponse<any | null> | null,
{data:iWithdrawDTO},
{
    rejectValue: iStateMessage;
}
>(
curriedGetThunkName("withdrawMoney"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({data}, {rejectWithValue}) => {
    try {
        const response = await walletServices.withdrawMoney(data);
        if (response) {
            const {httpStatusCode, data, message} = response;

            switch (httpStatusCode) {
                case httpStatusCodes.SUCCESS_OK: {
                    if (data && data.data) {
                        return {
                            data: {
                                data: data.data,
                                message,
                            }
                        };
                    } else {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
                default: {
                    return rejectWithValue({
                        httpStatusCode,
                        message,
                    });
                }
            }
        } else {
            return rejectWithValue({
                message: "No response received",
            });
        }
    } catch (error) {
        return rejectWithValue({
            message: "Something went wrong",
        });
    }
},
);

export const getHoldMoneyInfo = createAsyncThunk<
  iGenericResponse<any | null> | null,
void,
  {
      rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getHoldMoneyInfo"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (arg, {rejectWithValue}) => {
      try {
          const response = await walletServices.getHoldMoneyInfo();
          if (response) {
              const {httpStatusCode, data, message} = response;

              switch (httpStatusCode) {
                  case httpStatusCodes.SUCCESS_OK: {
                      if (data && data.data) {
                          return {
                            data:{
                                httpStatusCode,
                              data: data.data,
                              message,
                            }
                              
                          };
                      } else {
                          return rejectWithValue({
                              httpStatusCode,
                              message,
                          });
                      }
                  }
                  default: {
                      return rejectWithValue({
                          httpStatusCode,
                          message,
                      });
                  }
              }
          } else {
              return rejectWithValue({
                  message: "No response received",
              });
          }
      } catch (error) {
          return rejectWithValue({
              message: "Something went wrong",
          });
      }
  },
);

export const updateWithdrawStatus = createAsyncThunk<
iGenericResponse<any | null> | null,
{transactionId:string,data:iApprovedStatus},
{
    rejectValue: iStateMessage;
}
>(
curriedGetThunkName("updateWithdrawStatus"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({transactionId,data}, {rejectWithValue}) => {
    try {
        const response = await walletServices.updateWithdrawRequestStatus(transactionId,data);
        if (response) {
            const {httpStatusCode, data, message} = response;

            switch (httpStatusCode) {
                case httpStatusCodes.SUCCESS_OK: {
                    if (data && data.data) {
                        return {
                            data: {
                                data: data.data,
                                message,
                            }
                        };
                    } else {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
                default: {
                    return rejectWithValue({
                        httpStatusCode,
                        message,
                    });
                }
            }
        } else {
            return rejectWithValue({
                message: "No response received",
            });
        }
    } catch (error) {
        return rejectWithValue({
            message: "Something went wrong",
        });
    }
},
);
